<template>
  <b-container class="profile-loanable" fluid v-if="item && routeDataLoaded">
    <vue-headful :title="fullTitle" />

    <b-row>
      <b-col>
        <h1 v-if="item.name">{{ item.name }}</h1>
        <h1 v-else>
          <em>{{ $t("nouveau") | capitalize }} {{ $tc("véhicule", 1) }}</em>
        </h1>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <loanable-form
          :loanable="item"
          :form="form"
          :loading="loading"
          @submit="submitLoanable"
          :show-reset="!!item.id"
          :changed="changed"
          @reset="reset"
          :center="center"
        />
      </b-col>
    </b-row>
  </b-container>
  <layout-loading v-else />
</template>

<script>
import LoanableForm from "@/components/Loanable/LoanableForm.vue";

import Authenticated from "@/mixins/Authenticated";
import DataRouteGuards from "@/mixins/DataRouteGuards";
import FormMixin from "@/mixins/FormMixin";
import UserMixin from "@/mixins/UserMixin";

import locales from "@/locales";

import { capitalize } from "@/helpers/filters";

export default {
  name: "ProfileLoanable",
  mixins: [Authenticated, DataRouteGuards, FormMixin, UserMixin],
  components: {
    LoanableForm,
  },
  computed: {
    communityCenter() {
      if (!this.item.community) {
        if(this.user.communities && this.user.communities[0]) {
          return this.user.communities[0].center_google;
        } else {
          return null;
        }
      }

      // transform array [lat, lng] format into google format {lat: lat, lng: lng}
      return Array.isArray(this.item.community.center) ?
        { lat: this.item.community.center[0], lng: this.item.community.center[1] } :
        this.item.community.center;
    },
    center() {
      return this.communityCenter || this.defaultCenter;
    },
    fullTitle() {
      const parts = [
        "Coloc'Auto",
        capitalize(this.$i18n.t("titles.profile")),
        capitalize(this.$i18n.tc("véhicule", 2)),
      ];

      if (this.pageTitle) {
        parts.push(this.pageTitle);
      }

      return parts.reverse().join(" | ");
    },
    defaultCenter() {
      // default center is near Mobicoop place in Nancy, France
      return { lat: 48.69385, lng: 6.17902 };
    },
    pageTitle() {
      return this.item.name || capitalize(this.$i18n.tc("véhicule", 1));
    },
  },
  methods: {
    formMixinCallback(){
      if( !this.item.id ) {
        if( this.$store.state.communities.current ){
          // set current community as the default loanable community
          this.item.community_id = this.$store.state.communities.current
          this.item.community = {id: this.$store.state.communities.current}
        } else {
          // set user main community as the default loanable community
          this.item.community = this.user.main_community;
          this.item.community_id = this.user.main_community.id;
        }
      }
    },
    async submitLoanable() {
      const isNew = !this.item.id;

      await this.submit();

      if (isNew) {
        this.$store.commit("addNotification", {
          content:
            "Votre véhicule a bien été créé. Veuillez maintenant ajouter des disponibilités dans la section du bas.",
          title: "Véhicule créé",
          variant: "success",
          type: "loanable",
        });
      } else {
        this.$store.commit("addNotification", {
          content: "Le véhicule a été enregistré avec succès.",
          title: "Véhicule enregistré",
          variant: "success",
          type: "loanable",
        });
      }
    },
  },
  i18n: {
    messages: {
      en: {
        ...locales.en.loanables,
        ...locales.en.forms,
        profile: { ...locales.en.profile },
        titles: { ...locales.en.titles },
      },
      fr: {
        ...locales.fr.loanables,
        ...locales.fr.forms,
        profile: { ...locales.fr.profile },
        titles: { ...locales.fr.titles },
      },
    },
  },
};
</script>

<style lang="scss"></style>
